import React, { FC, useState } from 'react'

import { ChromePicker } from 'react-color'
import { Icon } from '@iconify/react'

import styles from './_.module.css'

type Props = {
  values?: string[]
  onAddition: (val: string, replaceIndex: number) => void
  deleteColor: (index: number) => void
  disabled?: boolean
}

export const ColorPicker: FC<Props> = ({
  values,
  onAddition,
  deleteColor,
  disabled
}) => {
  const [showColorPicker, toggleColorPicker] = useState(false)
  const [updateIndex, setUpdateIndex] = useState(-1)
  const [activeColor, setActiveColor] = useState('#000')
  return (
    <div className={styles.colorPickerWrap}>
      {showColorPicker && (
        <div
          role="none"
          onClick={() => {
            if (!disabled) {
              toggleColorPicker(false)
              if (updateIndex === -1) {
                onAddition(activeColor, updateIndex)
              }
              setUpdateIndex(-1)
              setActiveColor('#000')
            }
          }}
          className={styles.backdropPicker}
        />
      )}
      <div className={styles.colorPickerHeaderWrap}>
        {values?.map((value, index) => {
          return (
            <div
              key={index}
              role="none"
              onClick={() => {
                if (!disabled) {
                  toggleColorPicker(true)
                  setUpdateIndex(index)
                }
              }}
              className={styles.color}
              style={{
                background: value
              }}
            >
              <div className={styles.colorBack}>
                <div
                  className={styles.colorActive}
                  style={{
                    background: value
                  }}
                />
                <div
                  className={styles.closeColor}
                  role="none"
                  onClick={e => {
                    e.stopPropagation()
                    if (!disabled) {
                      deleteColor(index)
                    }
                  }}
                >
                  <Icon
                    icon="ant-design:close-outlined"
                    className={styles.closeColorIcon}
                  />
                </div>
              </div>
            </div>
          )
        })}
        <Icon
          icon="ant-design:plus-outlined"
          className={styles.colorPlus}
          onClick={() => {
            if (!disabled) {
              toggleColorPicker(true)
              setUpdateIndex(-1)
            }
          }}
        />
      </div>
      {showColorPicker && (
        <ChromePicker
          disableAlpha={true}
          color={updateIndex > -1 && values ? values[updateIndex] : activeColor}
          className={styles.pickerFocused}
          onChangeComplete={updatedColor => {
            updateIndex === -1
              ? setActiveColor(updatedColor.hex)
              : onAddition(updatedColor.hex, updateIndex)
          }}
        />
      )}
    </div>
  )
}
